<template>
  <sidebar
  :addTitle="$t('GradeControl.Destination.AddNew')"
  :editTitle="$t('GradeControl.Destination.Edit')"
  :isSidebarActive="isSidebarActive"
  :data="data"
  @onNewData="newData"
  @onEditData="editData"
  @closeSidebar="closeSidebar">
    <ValidationObserver ref="observer">
      <div class="p-6">
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <ValidationProvider :name="$t('GradeControl.Destination.Name')" rules="required" v-slot="{ errors }">
              <validated-input
              :disabled="id !== 0"
              :label="$t('GradeControl.Destination.Name')"
              v-model="name"
            ></validated-input>
            <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12" class="mr-5">
            <form-label>{{$t('GradeControl.Destination.Type')}}</form-label>
            <ValidationProvider :name="$t('GradeControl.Destination.Type')" rules="required" v-slot="{ errors }">
                <v-select
                  label="name"
                  :options="destinationTypes"
                  v-model="destinationType"
                  :reduce="p => p.id"
                  class="w-full"
                />
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>

          </vs-col>
        </vs-row>
      </div>
    </ValidationObserver>
    <template v-slot:footer>
      <vs-button class="mr-6" @click="submitData">{{ $t('Submit') }}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t('Cancel') }}</vs-button>
    </template>
  </sidebar>
</template>

<script>
import {
  ValidatedInput,
  ValidationMessage,
  Sidebar,
  FormLabel
} from "../../../../../shared/components";

import vSelect from 'vue-select';

import DestinationTypeEnum from "@/app/geo/gradecontrol/DestinationTypeEnum.js";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    projectId: {
      type: Number,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    Sidebar,
    FormLabel,
    vSelect
  },
  data() {
    return {
      id: 0,
      name: "",
      destinationType: 1,
      isActive: true,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      destinationTypes: DestinationTypeEnum.definition
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.closeSidebar();
        }
      }
    }
  },
  methods: {
    newData() {
      this.initValues();
      this.$refs.observer.reset();
    },
    editData() {
      const { id, name, destinationType } = JSON.parse(JSON.stringify(this.data));
      this.id = id;
      this.name = name;
      this.type = destinationType;
      this.$refs.observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.id) return;
     
      this.id = 0;
      this.name = "";
      this.destinationType = 1;
    },
    
    submitData() {
      this.$refs.observer.validate().then(result => {

        if (result) {
          const obj = {
            id: this.id,
            name: this.name,
            destinationType: this.destinationType,
            projectId: this.projectId
          };

          this.$vs.loading();
          if (this.id !== null && this.id > 0) {
            this.$store.dispatch("gradeControl/updateDestination", obj).then((result) => {
              this.$emit("onDestinationUpdated", result.data);
            }).finally(() => {
              this.$vs.loading.close();
            });
          } else {
            this.$store.dispatch("gradeControl/addDestination", obj).then((result) => {
              this.$emit("onDestinationInserted", result.data);
            }).finally(() => {
              this.$vs.loading.close();
            });
          }
        }
      });
    }
  }
};
</script>
